import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DigitalAddressDetails from './digital-address-details';
import { useMutation } from '@apollo/client';

import { IDigitalAddress } from '../../../../types/contact';
import { GET_ORG_DIGITAL_ADDRESSES, UPDATE_ORG_DIGITAL_ADDRESS } from '../../../../graphql/contact-gql';
import { DigitalAddressHandler } from './digital-address-details';
import { notifySuccess } from '../../../../services/notification';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import Button from '../../../common/button';

type DigitalAddressUpdateProps = {
    digitalAddress?: IDigitalAddress;
    isOpen: boolean;
    toggle: () => void;
}

const DigitalAddressUpdate = (props: DigitalAddressUpdateProps) => {
    const {digitalAddress, isOpen, toggle} = props
    const [updateDigitalAddress] = useMutation(UPDATE_ORG_DIGITAL_ADDRESS)


    const [validated, setValidated] = useState<boolean>(true)
    const digitalAddressRef = useRef<DigitalAddressHandler>(null)

    const saveDigitalAddress = () => {
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            setValidated(false)
            return
        }
        let digitalAddressInput = digitalAddressRef.current && digitalAddressRef.current.getDigitalAddress()
        updateDigitalAddress({
            variables: {
                orgId: digitalAddress?.businessEntityId,
                input: digitalAddressInput
            },
            refetchQueries: [{
                query: GET_ORG_DIGITAL_ADDRESSES,
                variables: { orgId: digitalAddress?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        let _validated = !!digitalAddressRef.current?.validate(false)
        setValidated(_validated)
    }

    return (
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Update an Organization Digital Address</ModalHeader>
            <ModalBody>
                <DigitalAddressDetails ref={digitalAddressRef} digitalAddress={digitalAddress} onChange={onChange} autoFocus={true} ></DigitalAddressDetails>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveDigitalAddress}  disabled={!validated}><SaveIcon/> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
  )
}

export default DigitalAddressUpdate
